import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "car" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21,9.75,19.3,5.96A2.249,2.249,0,0,0,17.191,4.5H6.809A2.249,2.249,0,0,0,4.7,5.96L3,9.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.5,16.468V18a1.5,1.5,0,0,0,3,0V16.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.5,16.468V18a1.5,1.5,0,0,1-3,0V16.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.875,12.75a.375.375,0,0,1,.375.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.5,13.125a.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.875,13.5a.375.375,0,0,1-.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,13.125a.375.375,0,0,1-.375.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.125,12.75a.375.375,0,0,0-.375.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.5,13.125a.375.375,0,0,0-.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.125,13.5a.375.375,0,0,0,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,13.125a.375.375,0,0,0,.375.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M2.75,9.75h18.5a2,2,0,0,1,2,2V15.5a1,1,0,0,1-1,1H1.75a1,1,0,0,1-1-1V11.75A2,2,0,0,1,2.75,9.75Z"
		})
	]
});
export default SvgCar;
